import { BaseConfig } from './environment.interface';

export const baseConfig: BaseConfig = {
  cost_basis_endpoint: '/us/XHTML/web/CostBasisAccountMaint/view/ViewPage.xhtml',
  account_setting_endpoint: '/mnt-profile-account-settings/paas/quick-links',
  accounts_and_trading_endpoint: '/mnt-profile-account-settings/paas/accounts-and-trading',
  cwp_prefix: '/cwp-change-of-ownership-angular',
  gifting_asset_endpoint: '/secure/gifting/assets',
  giftingIntelliDocs_endpoint:
    '/eel-esign-summary-webapp/?interviewId=11b4134e-20aa-4836-99b1-dea75bb0cc8b&ELF_ENTRY_POINT=true',
  gifting_overview_endpoint: '/gifting/overview',
  trustMultisignerIntelliDocs_endpoint:
    '/eel-esign-summary-webapp/?interviewId=38569f8b-e898-481e-9b6d-21ba633940b1&ELF_ENTRY_POINT=true',
  ineligible_endpoint: '/ineligible',
  inheritance_overview_endpoint: '/inheritance/overview',
  divorce_document_upload_endpoint: '/secure/divorce/upload',
  internal_transfer_from_endpoint: '/secure/internal-transfer/transfer-from',
  internal_transfer_details_endpoint: '/secure/internal-transfer/transfer-details',
  internal_transfer_intelledox_endpoint:
    '/eel-esign-summary-webapp/?interviewId=7feca89b-f955-4ff9-9544-2bdbe66b40d5&ELF_ENTRY_POINT=true',
  internal_transfer_overview_endpoint: '/internal-transfer/overview',
  internal_transfer_triage_endpoint: 'internal-transfer/triage',
  minor_overview_endpoint: '/minor-transfer/overview',
  mmx_endpoint: '/mmx-move-money/welcome',
  ona_endpoint: '/ona-open-account/account-selection/overview',
  pvr_endpoint: '/pvr-prospect-verify-register-angularv3/personal-info',
  singleSignerLimitJointTenantsWROSAccount: 500000,
  maxTransferValueForJointAndTrustAccount: 300000,
  gifting_triage_endpoint: '/gifting/triage',
};
